/* No chrome of its own: this sits inside the Muscle focus panel, which carries
   the heading and the border. */
.radar {
  display: flex;
  flex-direction: column;
}

.heading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.chartWrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg {
  width: 100%;
  max-width: 300px;
  height: auto;
}

@keyframes radarIn {
  from { opacity: 0; transform: scale(0.4); }
  to   { opacity: 1; transform: scale(1); }
}

.dataPolygon {
  transform-box: fill-box;
  transform-origin: center;
  animation: radarIn 0.5s ease both;
  animation-delay: 0.15s;
}

.dataPoint {
  transform-box: fill-box;
  transform-origin: center;
  animation: radarIn 0.3s ease both;
  animation-delay: 0.55s;
}

.axisLabel {
  fill: var(--soft);
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
}

.axisLabelHovered {
  fill: var(--amber-strong);
}

.tooltip {
  position: fixed;
  z-index: 9999;
  background: var(--canvas);
  border: 1px solid var(--border-md);
  border-radius: 8px;
  padding: 8px 12px;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  box-shadow: 0 6px 20px rgba(38, 33, 25, 0.18);
}

.tooltipLabel {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--amber-strong);
}

.tooltipValue {
  font-size: 0.85rem;
  font-variant-numeric: tabular-nums;
  color: var(--soft);
}

.tooltipDelta {
  font-size: 0.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding-top: 3px;
  border-top: 1px solid var(--border);
  margin-top: 2px;
}

.legend {
  display: flex;
  gap: 10px;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--muted);
}

.swatchCurrent {
  display: inline-block;
  width: 14px;
  height: 2px;
  background: var(--amber);
  border-radius: 999px;
}

.swatchPrev {
  display: inline-block;
  width: 14px;
  height: 0;
  border-top: 2px dashed var(--muted);
  opacity: 0.7;
}

.prevPolygon {
  transform-box: fill-box;
  transform-origin: center;
  animation: radarIn 0.5s ease both;
  animation-delay: 0.05s;
}

.up   { color: var(--up); }
.down { color: var(--down); }
.flat { color: var(--muted); }
